import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";
import SvgPdfIcon from "./SvgPdfIcon";
import SvgRemoveFile from "./SvgRemoveFile";
import NextImage from "@/app/components/lib/NextImage";
import { TempFile } from "../upload";

interface Props {
  file: TempFile;
  onRemoveClick: () => void;
}

const FileThumbmail: React.FC<Props> = ({ file, onRemoveClick }) => {
  const uploaded = file.url !== null && file.url !== "";
  return (
    <div className="file-thumbmail">
      <div className="file-image">
        {uploaded && (
          <div className="close-icon">
            <SvgRemoveFile onClick={onRemoveClick} />
          </div>
        )}
        {!uploaded ? (
          <SpinnerForBtn dark />
        ) : file.isImage ? (
          <div className="thumbmail-container">
            <NextImage alt="file-icon" src={file.url} objectFit="contain" />
          </div>
        ) : (
          <SvgPdfIcon />
        )}
      </div>
    </div>
  );
};

export default FileThumbmail;
